export default {
  labelLancamentoMastiteLote: 'Lançamento de Mastite em Lote',
  selecioneTratamento: 'Selecione o tratamento',
  selecioneBacteria: 'Selecione a bactéria',
  selecioneTipoMastite: 'Selecione o tipo de mastite',
  selecioneCuraClinica: 'Selecione a cura clínica',
  selecioneGrau: 'Selecione o grau',
  selecioneTipoResultado: 'Selecione o tipo de resultado',
  labelRetornar: 'Retornar',
  labelTipoLeitura: 'Tipo Leitura',
  labelAcoes: 'Ações',
  btnResultados: 'Resultados',
  btnFichaVaca: 'Ficha da Vaca',
  btnTratamentos: 'Tratamentos',
  btnRelatorios: 'Relatórios',
  labelParabens: 'Parabéns, você está',
  labelEconomizando: 'economizando!',
  btnSaibaMais: 'Saiba Mais',
  labelLojaOnfarm: 'Loja Onfarm',
  labelDescricaoLojaOnfarm: 'O que é a Loja da Onfarm e',
  labelBeneficiosLojaOnfarm: 'quais os benefícios que ela traz',
  labelVoceTem: 'Você tem',
  btnAcessarLoja: 'Acessar Loja',
  btnLancamento: 'Lançamento',
  labelResultados: 'Resultados',
  labelQuarto: 'Quarto',
  labelTarefas: 'Tarefas',
  labelFiltrar: 'Filtrar',
  labelPesquisar: 'Pesquisar',
  labelBrinco: 'Brinco',
  labelData: 'Data',
  labelTipo: 'Tipo',
  labelTratamentos: 'Tratamentos',
  labelLeituraResultados: 'Leitura de Resultados',
  labelResultado: 'Resultado',
  labelCuraClinica: 'Cura clínica:',
  labelVoceEconomizou: 'Você economizou:',
  labelMinhasTarefas: 'Minhas Tarefas',
  labelLancamentosRapidos: 'Lançamentos Rápidos',
  btnLancarMastite: 'Lançar Mastite',
  labelUsuario: 'Usuário',
  login_labelDigiteNomeUsuario: 'Digite o nome do usuário',
  labelSenha: 'Senha',
  login_labelDigiteSuaSenha: 'Digite sua senha',
  login_labelEsqueciMinhaSenha: 'Esqueci minha senha',
  login_btnEntrar: 'ENTRAR',
  login_btnEntrando: 'ENTRANDO...',
  login_returnCamposUsuarioObrigatorio: 'Campos de usuário e senha são obrigatórios!',
  login_returnDefinirNovaSenha: 'É necessário definir uma nova senha.',
  forgotPassword_labelUsuario: 'Usuário',
  forgotPassword_labelDigiteNomeUsuario: 'Digite o nome do usuário',
  forgotPassword_labelSelecioneReceberSenhaTemporaria: 'Será enviada uma senha temporária por Whatshapp.',
  forgotPassword_btnEnviar: 'ENVIAR',
  forgotPassword_btnEnviando: 'ENVIANDO...',
  forgotPassword_returnNecessarioSelecionarOpcao: 'É necessário selecionar uma opção!',
  forgotPassword_returnCampoUsuarioObrigatorio: 'Campo de usuário é obrigatório!',
  forgotPassword_returnFoiEnviadoSenhaTemporaria: 'Foi enviado uma senha temporária por ',
  forgotPassword_returnFacaLogin: 'Faça login',
  labelBemVindo: 'Bem-vindo',
  labelSelecioneFazendaAvancar: 'Selecione a fazenda para avançar',
  farm_labelPesquiseFazenda: 'Pesquise uma fazenda',
  farm_btnProsseguir: 'Prosseguir',
  labelAjuda: 'Ajuda',
  footer_btnInicio: 'Inicio',
  labelNovoUsuario: 'Novo Usuário',
  footer_btnNotificacao: 'Notificação',
  homeBezerra_labelTitulo: 'Saúde da Bezerra',
  homeBezerra_btnIrparaLoja: 'Ir para loja',
  homeBezerra_btnMinhasTarefas: 'Minhas tarefas',
  homeBezerra_btnBancoColostro: 'Banco de Colostro',
  homeBezerra_btnColostragem: 'Colostragem',
  homeBezerra_btnTratamentos: 'Tratamentos',
  homeBezerra_btnFichaBezerra: 'Ficha da Bezerra',
  homeBezerra_btnDoencas: 'Doenças',
  labelGrafico: 'Gráficos',
  homeBezerra_btnRelatorio: 'Relatórios',
  homeBezerra_btnContato: 'Contato',
  homeBezerra_btnSincronizar: 'Sincronizar',
  labelTop5IntramamarioAgentes: 'Produtos mais utilizados pela comunidade OnFarmers',
  labelSelecioneAgentes: 'Selecione os agentes',
  labelOnfarmersTop5IntramamarioATB: 'Top 5 - ATB Intramamários',
  labelOnfarmersTop5InjetavelATB: 'Top 5 - ATB Injetável',
  labelOnfarmersTop5AntiflamatorioATB: 'Top 5 - ATB Antiflamatório',
  labelOnfarmersTop5IntramamariosAgentes: 'Top 5 - ATB Intramamários por agentes',
  labelOnfarmersDiasTratamentoIntramamariosAgentes: 'Dias de tratamento ATB intramamário por agente',
  labelOnfarmersCuraClinica: 'Cura clínica',
  labelMeusDados: 'Meus Dados',
  labelDadosUsuario: 'Dados do usuário',
  labelDadosFazenda: 'Dados da fazenda',
  labelAlterarSenha: 'Alterar senha',
  labelMinhasContas: 'Minhas contas',
  labelRastreioPedidos: 'Rastreio de Pedidos',
  labelVacasLactacao: 'Vacas em Lactação',
  labelUsuarioFazendas: 'Usuários/Fazendas',
  labelUsuarios: 'Usuários ',
  labelFazendas: 'Fazendas',
  labelAlternarFazenda: 'Alternar fazenda',
  labelArtigosVideos: 'Artigos e Vídeos',
  labelIntegracoes: 'Integrações',
  labelTokenOnfarm: 'Token OnFarm',
  labelParceiros: 'Parceiros',
  labelUtilidades: 'Utilidades',
  labelRepararBancoDados: 'Reparar Banco de Dados',
  labelDiagnosticoAparelho: 'Diagnóstico Aparelho',
  labelDados: 'Dados',
  labelExportarBancoDeDados: 'Exportar Banco de Dados',
  labelCentralNotificacao: 'Central de Notificações',
  labelSair: 'Sair',
  homeUbere_btnIrParaLoja: 'Ir para a loja',
  homeUbere_btnMInhasTarefas: 'Minhas tarefas',
  homeUbere_btnFichaVaca: 'Ficha da vaca',
  homeUbere_btnTratamentos: 'Tratamentos',
  btnGraficos: 'Gráficos',
  homeUbere_btnRelatorios: 'Relatórios',
  labelAnaliseCbtTanque: 'Análise CBT Tanque',
  homeUbere_btnContato: 'Contato',
  btnComunidadeOnfarmers: 'Comunidade',
  homeUbere_btnSincronizar: 'Sincronizar',
  homeUbere_btnRumiTank: 'Última medição',
  dadosUsuario_labelDadosUsuario: 'Dados do usuário',
  dadosUsuario_labelDadosFazenda: 'Dados da Fazenda',
  labelNome: 'Nome',
  labelID: 'ID',
  labelLogin: 'Login',
  labelPerfil: 'Perfil',
  labelEmail: 'E-mail',
  labelTelefone: 'Telefone',
  labelFazenda: 'Fazenda',
  labelIdioma: 'Idioma',
  labelAtivarPopupCuraClinica: 'Ativar Pop-up Cura Clínica',
  labelAtivarPopupVacasLactacao: 'Ativar Pop-up Vacas em lactação',
  dadosUsuario_returnAtualizadoSucesso: 'Atualizado com sucesso!',
  labelAtualizar: 'Atualizar',
  labelLaticinios: 'Laticinios',
  labelNumVacasLactacao: 'Nº de vacas em lactação',
  labelVolumeLeite: 'Volume de leite (L/dia)',
  labelSistemaProducao: 'Sistema de produção',
  labelCidade: 'Cidade',
  labelEstado: 'Estado',
  labelOrganizacaoPrincipal: 'Organização principal',
  alterarSenha_labelCriarNovaSenha: 'Criar nova senha',
  alterarSenha_labelDigiteNovaSenha: 'Digite uma nova senha',
  alterarSenha_labelConfirmarNovaSenha: 'Confirmar nova senha',
  alterarSenha_labelConfirmeNovaSenha: 'Confirme sua nova senha',
  alterarSenha_returnSenhaConfirmacaoSenhaObrigatorios: 'Senha e confirmação de senha são obrigatórios!',
  alterarSenha_returnMinimoDigitos: 'Mínimo de 6 dígitos',
  alterarSenha_returnSenhasDevemIguais: 'As senhas devem ser iguais!',
  returnSenhaAlteradaSucesso: 'Senha alterada com sucesso!',
  alterarSenha_returnErroAlterarSenha: 'Erro ao alterar a senha!',
  alterarSenha_returnTenteNovamenteInstantes: 'Tente novamente em instantes.',
  rastreioPedido_filtroEnviado: 'Enviado',
  rastreioPedido_filtroAguardandoFaturamento: 'Previsto',
  rastreioPedido_filtroAutorizado: 'Enviado',
  rastreioPedido_filtroFaturado: 'Faturado',
  rastreioPedido_filtroCancelado: 'Cancelado',
  rastreioPedido_filtroDevolvido: 'Devolvido',
  rastreioPedido_filtroDevolvidoParcialmente: 'Devolvido Parcialmente',
  rastreioPedido_filtroDenegado: 'Denegado',
  rastreioPedido_filtroPrevisto: 'Previsto',
  rastreioPedido_filtroEntregue: 'Entregue',
  labelPedido: 'Pedido',
  rastreioPedido_colStatus: 'Status',
  rastreioPedido_colData: 'Data',
  rastreioPedido_filtroPedido: 'Pedido:',
  rastreioPedido_filtroStatus: 'Status:',
  rastreioPedido_filtroDataVencimento: 'Data de vencimento:',
  rastreioPedido_filtroFILTRAR: 'FILTRAR',
  labelPeriodo: 'Período',
  vacaLactacao_colQuantidade: 'Quantidade',
  vacaLactacao_filtroQuantidade: 'Quantidade:',
  usuario_colUsuário: 'Usuário',
  usuario_colPerfil: 'Perfil',
  usuario_colFazenda: 'Fazenda',
  usuario_title: 'Usuários',
  usuario_filtoUsuario: 'Usuário:',
  usuario_returnCampoNomeObrigatorio: 'Campo nome é obriagtório!',
  usuario_returnCampoLoginObrigatorio: 'Campo login é obrigatório!',
  usuario_returnSelecioneAoMenosUmPerfil: 'Selecione ao menos um perfil!',
  usuario_returnSelecioneAoMenosUmaFazenda: 'Selecione ao menos uma fazenda!',
  usuario_returnHabiliteAoMenosUmaPermissao: 'Habilite ao menos uma permissão!',
  usuario_labelNome: 'Nome',
  usuario_labelLogin: 'Login',
  labelPerfilUsuario: 'Perfil do Usuário',
  usuario_labelFazendas: 'Fazendas',
  usuario_labelEmail: 'Email',
  usuario_labelTelefone: 'Telefone',
  labelPermissoesUsuario: 'Permissões do usuário:',
  usuario_returnEsteLoginJaExiste: 'Este Login já existe insira outro por favor!',
  repararBD_returnRepararBanco: 'Reparar banco',
  repararBD_returnApagandoBanco: 'Apagando banco...',
  repararBD_returnReparacaoConcluidaSucesso: 'Reparação concluída com sucesso',
  repararBD_returnReparando: 'Reparando...',
  repararBD_returnDesejaRealmenteAlternarFazenda: 'Deseja realmente alternar de fazenda?',
  repararBD_returnDesejaRealmenteRepararBanco: 'Deseja realmente reparar o banco de dados?',
  repararBD_returnIssoPodeApagarTodosDados: 'Isso pode apagar todos seus dados',
  repararBD_returnAtencao: 'Atenção!',
  repararBD_returnConstamDadosParaSincronizar: 'Constam dados para sincronizar, gostaria de sincronizar?',
  repararBD_returnIssoApagarTodosDados: 'Isso irá apagar todos seus dados',
  export_labelExportBD: 'Banco de Dados',
  export_labelTamBanco: 'Tamanho do banco de dados local',
  export_labelExportar: 'ENVIAR CÓPIA DO BANCO',
  export_labelExportando: 'ENVIANDO...',
  export_labelExportado: 'Enviado',
  export_labelExportadocaoConcluida: 'Envio concluído com sucesso!',
  export_labelExportadoModal: 'Enviando',
  export_labelExportadoDescricaoModal: 'Enviando cópia do banco de dados local para o servidor',
  labelNovaFazenda: 'Nova Fazenda',
  labelNomeProprietario: 'Nome do Proprietário',
  labelVideos: 'Vídeos',
  labelVideo: 'Vídeo',
  labelArtigos: 'Artigos',
  labelArtigo: 'Artigo',
  labelUbere: 'Úbere',
  labelBezerra: 'Bezerra',
  labelTitulo: 'Título',
  artigo_labelTipo: 'Tipo',
  labelCategoria: 'Categoria',
  labelTutorias: 'Tutorias',
  labelIdFazenda: 'id Fazenda',
  labelGerandoToken: 'Gerando Token...',
  labelGerarToken: 'Gerar Token',
  labelTokenGerado: 'Token Gerado',
  diagnostico_labelDiagosticoAparelho: 'Diagóstico Aparelho',
  diagnostico_labelArmazenamento: 'Armazenamento',
  diagnostico_labelDoArmazenamento: 'do armazenamento',
  diagnostico_labelMemoria: 'Memória',
  diagnostico_labelDaMemoriaRAM: 'da memória RAM',
  diagnostico_labelInternetWifi: 'Internet - Wifi',
  diagnostico_labelDoSinal: 'do Sinal',
  diagnostico_labelFabricanteModelo: 'Fabricante/Modelo',
  diagnostico_labelPlataforma: 'Plataforma',
  notificacao_labelAtiveDesativeNotificacao: 'Ative ou desative Notificações',
  fichaVaca_labelInformaçãoSuplementar: 'Informação Suplementar',
  fichaVaca_labelVolumeLeite: 'Volume de Leite',
  fichaVaca_labelNumero: 'Número',
  fichaVaca_labelInibidorMicrobiologico: 'Inibidor Microbiológico',
  fichaVaca_labelMotivoDescarte: 'Motivo de Descarte',
  fichaVaca_labelGordura: 'Gordura',
  fichaVaca_labelProteína: 'Proteína',
  fichaVaca_labelLactose: 'Lactose',
  fichaVaca_labelSolidosTotais: 'Sólidos Totais',
  fichaVaca_labelCCS: 'CCS',
  fichaVaca_labelCCP: 'CCP',
  fichaVaca_labelNUreico: 'N Ureico',
  fichaVaca_labelCaseina: 'Caseina',
  fichaVaca_labelCrioscopia: 'Crioscopia',
  fichaVaca_labelAniversario: 'Aniversário',
  fichaVaca_labelDataCCS: 'Data CCS',
  fichaVaca_labelDataUltimoRegistroLeite: 'Data do Último Registro de Leite',
  fichaVaca_labelUltimoRegistroLeiteKg: 'Último Registro de Leite em Kg',
  fichaVaca_labelDataUltimoParto: 'Data Ultimo Parto',
  fichaVaca_labelDataPrevistaSecagem: 'Data Prevista Secagem',
  fichaVaca_labelDEL: 'DEL',
  fichaVaca_labelDataProducaoLeite: 'Data Produção de Leite',
  fichaVaca_labelProducaoLeite: 'Produção de Leite',
  fichaVaca_labelDataMastite: 'Data da Mastite',
  fichaVaca_labelImportacao: 'Importação',
  fichaVaca_labelNdeCasos: 'Nº de Casos Clínicos',
  tratamento_returnCampoDescricaoObrigatorio: 'Campo Descrição obrigatório',
  tratamento_returnSelecioneUmTipoMastite: 'Selecione um tipo de mastite',
  tratamento_returnSelecioneUmGrau: 'Selecione um grau',
  tratamento_returnSelecioneUmaObservacao: 'Selecione uma observação',
  tratamento_returnSelecioneUmResultado: 'Selecione um Resultado',
  tratamento_returnSelecionePeloMenosUmaBacteria: 'Selecione pelo menos uma bacteria',
  tratamento_returnSelecioneUmOpcaoAtivo: 'Selecione um opção em ativo',
  tratamento_returnSalvoComSucesso: 'Salvo com sucesso',
  returnDesejaMesmoSalvarEsteTratamento: 'Deseja mesmo salvar este tratamento',
  tratamento_labelEditarTratamento: 'Editar tratamento',
  tratamento_labelNovoTratamento: 'Novo tratamento',
  labelDescricao: 'Descrição',
  labelCodigoIntegracaoIdeagri: 'Código Integração ideagri',
  labelTipoMastite: 'Tipo Mastite',
  tratamento_labelGrau: 'Grau:',
  tratamento_labelEscoredeChancedeCura: 'Escore de Chance de Cura:',
  tratamento_labelObservação: 'Observação:',
  labelAntibioticoInjetavel: 'Antibiótico injetável:',
  tratamento_labelSelante: 'Selante:',
  tratamento_labelAtivo: 'Ativo? :',
  tratamento_labelAtualizarProtocolo: 'ATUALIZAR PROTOCOLO',
  tratamento_labelAdicionarProtocolo: 'ADICIONAR PROTOCOLO',
  tratamento_labelDigiteValorValido: 'Digite valor Valído',
  tratamento_labelBaixo: 'Baixo',
  tratamento_labelMédio: 'Médio',
  tratamento_labelAlto: 'Alto',
  labelLeve: 'Leve',
  labelModerado: 'Moderado',
  labelGrave: 'Grave',
  tratamento_labelCSSAlta: 'CCS Alta',
  labelManha: 'Manhã',
  labelTarde: 'Tarde',
  labelNoite: 'Noite',
  labelRepetirEsteMedicamento: 'Repetir este medicamento durante o dia nos períodos:',
  tratamento_labelPesquiseProdutos: 'Pesquise produtos',
  tratamento_labelPesquise: 'Pesquise',
  labelAdicionarMedicamento: 'Adicionar medicamento',
  tratamento_returnDigiteNomePesquisa: 'Digite nome no campo de pesquisa',
  labelSelecioneBacterias: 'Selecione as bacterias',
  tratamento_labelPesquiseBacteria: 'Pesquise a bacteria...',
  home_labelVoceEconomizouAteMomento: 'Você economizou até o momento:',
  labelOcorrenciaMastiteClinica: 'Ocorrência Mastite Clínica',
  labelIncidenciaMastiteClinica: 'Incidência de Mastite Clínica',
  labelAgentesCausadoresMastite: 'Agentes causadores de mastite',
  labelPrevalenciaGrupoGRAM: 'Prevalência por grupo GRAM',
  labelCuraClinicaDiagnóstico: 'Cura clínica por diagnóstico',
  labelConsolidadoDiagnostico: 'Consolidado - Diagnósticos',
  labelCasosMastiteTratamento: 'Casos de Mastite e tratamentos por dia',
  labelConsolidadoDiagnosticoTratamento: 'Consolidado - diagnósticos, tratamentos e cura clínica',
  labelExportacaoIdeagri: 'Exportação - Ideagri',
  labelExportacaoACL: 'Exportação - ACL',
  tanque_labelAnaliseCBTTanque: 'Análise CBT Tanque',
  labelTanque: 'Tanque',
  tanque_labelData: 'Data',
  tanque_labelCCS: 'CCS',
  tanque_labelCBT: 'CBT',
  tanque_labelNovoTanque: 'Novo Tanque',
  tanque_labelDescricao: 'Descrição',
  labelVolume: 'Volume',
  labelProteina: 'Proteína',
  tanque_labelDigiteDescricao: 'Digite a descrição',
  tanque_labelDigiteVolume: 'Digite o volume',
  tanque_labelDataColeta: 'Data coleta',
  labelGordura: 'Gordura',
  tanque_labelLERCODIGODEBARRAS: 'LER CÓDIGO CBTest',
  tanque_labelDigiteProteina: 'Digite a proteína',
  tanque_labelDataLancamento: 'Data do lançamento',
  tanque_labelCampoDescricaoNaoPreenchido: 'Campo descrição não preenchido',
  labelEssaPlacaJaFoiUtilizada: 'Essa Placa já foi utilizada',
  tanque_labelValidando: 'Validando...',
  tanque_labelSalvarNovoTanque: 'SALVAR NOVO TANQUE',
  tanque_labelTanqueNaoConstaFotoServidor: 'Tanque não consta foto no servidor',
  labelAjudaGuiaCores: 'Ajuda Guia de Cores',
  labelContagemColonias: 'Contagem de colônias',
  labelManual: 'Manual',
  labelAutomatico: 'Automático',
  labelNumColonias: 'Nº de colonias',
  labelDiluicao: 'Diluição',
  labelCBTest: 'CBTest',
  labelAtualizarTanque: 'ATUALIZAR TANQUE',
  labelEmAnalise: 'Em análise',
  returnTanqueAtualizandoComSucesso: 'Tanque atualizado com sucesso!',
  tanque_labelCampoTipoContagem: 'Selecione o tipo de contagem!',
  boasVindas_textTexto001: 'BOAS-VINDAS!',
  boasVindas_textTexto002: 'Oi, eu sou a',
  boasVindas_textTexto003: 'Bem vindo ao Novo OnfarmApp!',
  boasVindas_textTexto004: 'Enquanto você aguarda a sincronização, segue uma dica do Novo OnFarmApp:',
  boasVindas_textTexto005: 'Aqui você também contará com a Rumi, nossa inteligência artificial.',
  boasVindas_textTexto006: 'ativada',
  boasVindas_textTexto007: ' e seguirá fazendo seu trabalho toda vez que você precisar ler um resultado na placa, ou de uma análise do escore de chance de cura dos casos de mastite clínica.',
  boasVindas_textTexto008: 'VISITE MINHA PÁGINA',
  colostro_labelLote: 'Lote',
  colostro_labelData: 'Data',
  colostro_labelVolume: 'Volume',
  colostro_labelBrix: 'Brix',
  colostro_labelCBT: 'CBT',
  colostro_labelBancoColostro: 'Banco de Colostro',
  colostro_labelBrincoBezerra: 'Brinco da bezerra',
  colostro_labelDigiteUmLote: 'Digite um lote',
  colostro_labelBrixColostro: 'Brix Colostro',
  returnColostroAtualizadoSucesso: 'Colostro atualizado com sucesso!',
  colostro_returnAdicioneBrinco: 'Adicione o brinco',
  colostro_returnAdicioneAoMenosUmPacote: 'Adicione ao menos um pacote',
  colostro_returnPorFavorAnexeUmaImagem: 'Por favor, anexe uma imagem',
  returnFavorAguardeProcessamentoAutomatico: 'Favor aguarde o processamento automático',
  colostro_returnErroProcessarImagemTireUmaNovaFoto: 'Erro ao processar imagem. Tire uma nova foto e tente novamente!',
  colostro_btnEditarColostro: 'Editar colostro',
  colostro_btnNovoColostro: 'Novo colostro',
  colostro_labelVaca: 'Vaca',
  colostro_labelDensidadeColostometro: 'Densidade (Colostômetro)',
  colostro_btnSALVARCOLOSTRO: 'SALVAR COLOSTRO',
  colostro_btnADICIONARCOLOSTRO: 'ADICIONAR COLOSTRO',
  colostro_btnADICIONANDO: 'ADICIONANDO...',
  colostro_labelDataCongelamento: 'Data do congelamento',
  colostro_labelAdicioneQuantidadePacotesVolumesForamCongelados: 'Adicione quantidade de pacotes e volumes que foram congelados',
  colostro_labelInsiraPacotesVolumes: 'Insira pacotes e volumes',
  colostro_labelPacotes: 'Pacotes',
  colostro_labelVolumeLPacotes: 'Volume(L/Pacotes)',
  colostro_labelAdicionarPacotesVolume: 'Adicionar Pacotes e Volume',
  colostro_labelNumPacotes: 'Nº Pacotes',
  colostro_labelVolumePct: 'Volume Pct.',
  colostro_labelVolumeTotal: 'Vol. Total',
  colostro_labelTotal: 'Total',
  colostro_labelEssaPlacaJaFoiUtilizada: 'Essa Placa já foi utilizada',
  colostro_labelLERCODIGOBARRAS: 'LER CÓDIGO CBTest',
  colostro_labelValidando: 'Validando...',
  lancBezerra_btnNovoColostro: 'Novo Colostro',
  lancBezerra_btnNovaColostragem: 'Nova Colostragem',
  lancBezerra_labelLeituraResultados: 'Leitura de Resultados',
  colostragem_labelColostragem: 'Colostragem',
  colostragem_labelBrincoBezerra: 'Brinco da bezerra',
  colostragem_labelLote: 'Lote',
  colostragem_labelDigiteUmLote: 'Digite um lote',
  colostragem_labelNascimento: 'Nascimento',
  colostragem_labelBrixColostro: 'Brix Colostro',
  colostragem_labelCBT: 'CBT',
  colostragem_labelBrixSangue: 'Brix Sangue',
  colostragem_labelBrix: 'Brix',
  colostragem_labelSangue: 'Sangue',
  colostragem_labelEditarColostragem: 'Editar Colostragem',
  colostragem_labelNovaColostragem: 'Nova Colostragem',
  colostragem_labelProteinaSerica: 'Proteina sérica',
  colostragem_labelDataNascimento: 'Data nascimento',
  colostragem_labelVolume: 'Volume',
  colostragem_labelSelecioneColostro: 'Selecione o colostro',
  colostragem_labelLoteNecessárioAdicionarNovoPacote: 'Lote é necessário para Adicionar um novo pacote',
  colostragem_labelAdicionarPacotes: 'Adicionar Pacotes',
  colostragem_labelDesejaRealmenteExcluirEssePacote: 'Deseja Realmente excluir esse pacote?',
  colostragem_labelVolumeLPacotes: 'Volume(L/Pacotes)',
  colostragem_labelLoteNaoPodeSerVazio: 'Lote não pode ser vazio',
  colostragem_labelSALVARCOLOSTRAGEM: 'SALVAR COLOSTRAGEM',
  colostragem_labelPesoNascimento: 'Peso Nascimento',
  labelLoteNaoEncontrado: 'Lote não encontrado',
  graficoBezerra_labelQualidadeColostroCBT: 'Qualidade Colostro (CBT)',
  graficoBezerra_labelQualidadeColostroBRIX: 'Qualidade Colostro (BRIX)',
  graficoBezerra_labelQualidadeColostroIgGCBT: 'Qualidade Colostro (IgG e CBT)',
  graficoBezerra_labelQualidadeColostragem: 'Qualidade Colostragem',
  graficoBezerra_labelDoencas: 'Doenças',
  graficoBezerra_labelConsolidado: 'Consolidado',
  graficoBezerra_labelExportar: 'Gerar relatório',
  novaHome_labelVerificandoConexao: 'Verificando conexão...',
  novaHome_labelAguardeEnquantoVerificamosSuaConexao: 'Aguarde enquanto verificamos sua conexão com a internet.',
  novaHome_labelBuscandoSinal: 'Buscando sinal...',
  novaHome_labelRumiEstaOnline: 'A Rumi está online!',
  novaHome_labelVocePodeContarRumiFazerLeituraAutomatica: 'Você pode contar com a Rumi para fazer a leitura automática de diagnósticos.',
  novaHome_labelFazerLeituraResultados: 'Fazer leitura de resultados',
  novaHome_labelRumiEstaOffline: 'A Rumi está offline!',
  novaHome_labelVoceEstaSemConexaoInternet: 'Você está sem conexão com a internet e só poderá fazer leituras manuais.',
  novaHome_labelSincronizandoDados: 'Sincronizando Dados...',
  novaHome_labelProgresso: 'Progresso: ',
  novaHome_labelSincronizacaoDisponivel: 'Sincronização Disponível',
  novaHome_labelNovosDadosSincronizarServidor: ' novos dados para sincronizar com o servidor',
  novaHome_labelSincronizarDadosAgora: 'Sincronizar dados agora',
  novaHome_labelVoceJaEconomizou: 'Você já economizou:',
  novaHome_labelSemConexaoComInternet: 'Sem conexão com a internet',
  novaHome_labelTenteMaisTarde: 'Tente mais tarde',
  novaHome_labelSemWhatsapp: 'Sem Whatsapp',
  novaHome_labelWhatsappNaoFoiEncontrado: 'Whatsapp não foi encontrado. Instale-o e tente novamente',
  novaHome_labelTarefasEmAberto: 'Tarefas em aberto',
  novaHome_labelVerTodas: 'Ver todas',
  novaHome_labelNenhumaTarefaParaHoje: 'Nenhuma tarefa para hoje.',
  novaHome_labelIrParaSaudeBezerra: 'Ir para Saúde da Bezerra',
  sincronismo_labelCarregando: 'Carregando...',
  sincronismo_labelPermissoes: 'Permissões',
  sincronismo_labelGrupos: 'Grupos',
  sincronismo_labelTopicosAjuda: 'Tópicos de Ajuda',
  sincronismo_labelFabricantes: 'Fabricantes',
  sincronismo_labelProdutos: 'Produtos',
  sincronismo_labelAgentes: 'Agentes',
  sincronismo_labelParametros: 'Parâmetros',
  sincronismo_labelAgentesParametros: 'Agentes Parâmetros',
  sincronismo_labelCategoriasNotificacoes: 'Categorias de Notificações',
  sincronismo_labelPreferenciasNotificacoes: 'Preferências de notificações',
  sincronismo_labelCondicoesNotificacoes: 'Condições de notificações',
  sincronismo_labelAnimais: 'Animais',
  sincronismo_labelFazendas: 'Fazendas',
  sincronismo_labelUsuarios: 'Usuários',
  sincronismo_labelVacasLactacao: 'Vacas Lactação',
  sincronismo_labelProtocolos: 'Protocolos',
  sincronismo_labelProtocolosProdutos: 'Protocolos - Produtos',
  sincronismo_labelDiagnosticos: 'Diagnósticos',
  sincronismo_labelTarefasProdutos: 'Tarefas - Produtos',
  sincronismo_labelProtocolosDiagnosticos: 'Protocolos Diagnósticos',
  sincronismo_labelProtocolosProdutosDiagnosticos: 'Protocolos - Produtos Diagnósticos',
  sincronismo_labelAnaliseTanque: 'Análise de Tanque',
  sincronismo_labelProtocolosBezerra: 'Protocolos Bezerra',
  sincronismo_labelBezerraProtocolosProdutos: 'Bezerra Protocolos - Produtos',
  sincronismo_labelDoencas: 'Doenças',
  sincronismo_labelTarefasBezerra: 'Tarefas Bezerra',
  sincronismo_labelTarefasBezerraProdutos: 'Tarefas Bezerra - Produtos',
  sincronismo_labelProtocolosDoencas: 'Protocolos Doenças',
  sincronismo_labelProtocolosProdutosDoencas: 'Protocolos - Produtos - Doenças',
  sincronismo_labelBancoColostro: 'Banco de Colostro',
  sincronismo_labelColostragem: 'Colostragem',
  sincronismo_labelPacotesColostro: 'Pacotes Colostro',
  sincronismo_labelColostragemColostro: 'Colostragem - Colostro',
  sincronismo_labelParceiros: 'Parceiros',
  sincronismo_labelConfiguracoesParceiros: 'Configurações dos parceiros',
  geral_labelDadosFazenda: 'Dados da Fazenda',
  labelSim: 'Sim',
  labelNao: 'Não',
  btnSalvarAlteracao: 'SALVAR ALTERAÇÃO',
  labelSalvar: 'SALVAR',
  labelSalvando: 'SALVANDO',
  geral_LabelFiltros: 'Filtros',
  geral_LabelRemoverFiltros: 'Remover Filtros',
  geral_returnSemConexaoInternet: 'Sem conexão com a internet',
  geral_returnTenteMaisTarde: 'Tente mais tarde',
  labelImportarDados: 'Importar dados',
  geral_btnAtualizar: 'ATUALIZAR',
  geral_btnAtualizando: 'ATUALIZANDO...',
  geral_returnSalvoComSucesso: 'Salvo com sucesso!',
  geral_returnSalvoComSucessoWhatshapp: 'Os dados de acesso serão enviados por WhatsApp para o contato de telefone informado.',
  geral_returnAtualizadoComSucesso: 'Atualizado com sucesso!',
  labelTodos: 'Todos',
  geral_returnEditadoComSucesso: 'Editado com sucesso!',
  geral_returnDesculpe: 'Desculpe',
  geral_returnDesejaRealmenteSair: 'Deseja realmente sair?',
  labelCancelar: 'Cancelar',
  geral_btnConfirmar: 'Confirmar',
  geral_labelDigiteAlgo: 'Digite algo',
  geral_returnSelecioneFazenda: 'Selecione uma fazenda',
  geral_labelResultados: 'Resultados',
  labelGrau: 'Grau',
  geral_labelCuraClinica: 'Cura clínica',
  labelEditar: 'Editar',
  labelExcluir: 'Excluir',
  geral_btnVisualizar: 'Visualizar',
  labelBacterias: 'Bacterias',
  geral_returnDesejaExcluirEsteDiagnostico: 'Deseja excluir este diagnóstico',
  labelFiltrarPor: 'Filtrar por',
  geral_labelDataInício: 'Data de Início',
  geral_labelDataFinal: 'Data final',
  labelVerMais: 'Ver mais',
  labelRealizarLeitura: 'Realizar leitura',
  geral_labelMaiorQue: 'Maior que',
  geral_labelMaiorIgualQue: 'Maior e igual que',
  geral_labelMenorQue: 'Menor que',
  geral_labelMenorIgualQue: 'Menor e igual que',
  labelMastiteClinica: 'Mastite Clínica',
  labelMastiteSubclínica: 'Mastite Subclínica',
  labelMastiteSemCultura: 'Mastite Sem Cultura',
  labelSecagem: 'Secagem',
  labelPosTratamento: 'Pós-Tratamento',
  labelPosParto: 'Pós-Parto',
  geral_labelFichaVaca: 'Ficha da Vaca',
  labelNumeroCaso: 'Nº Casos Clínicos',
  geral_returnErroFazerUploadArquivo: 'Erro ao fazer upload do arquivo!',
  geral_labelImportacaoDados: 'Importação de Dados',
  geral_labelSincronizando: 'Sincronizando',
  geral_returnSelecioneUmParceiro: 'Selecione um parceiro',
  labelDownloadTemplate: 'Download Template',
  geral_returnProcessarImportacao: 'Processar Importação',
  geral_returnBaixandoArquivo: 'Baixando Arquivo',
  geral_returnWebArquivo: 'Problema no download',
  geral_returnImportandoArquivo: 'Importando Arquivo',
  geral_returnSalvandoBibliotecaMídia: 'Salvando na biblioteca de mídia',
  geral_returnBaixandoWeb: 'O download do arquivo pode ser baixado pela WEB',
  geral_returnEnviandoDadoParaServidor: 'Enviando dado para o servidor',
  labelAgentes: 'Agentes',
  geral_labelSelante: 'Selante',
  labelCompartilhar001: 'Compartilhar',
  geral_labelCopiar: 'Copiar',
  labelStatus: 'Status',
  labelNovoTratamento: 'Novo Tratamento',
  btnExameMicrobiologico: 'Exame Microbiológico',
  btnNovaMastiteClinicaSemExame: 'Nova Mastite clínica SEM Exame',
  geral_labelAnaliseCbtTanque: 'Análise CBT Tanque',
  geral_labelSaudeBezerra: 'Saúde da Bezerra',
  geral_labelSaudeUbere: 'Saúde do Úbere',
  labelClinica: 'Clínica',
  labelSubclinica: 'Subclínica',
  labelSemCultura: 'Sem Cultura',
  labelSemResultado: 'Sem Resultado',
  labelNegativo: 'Negativo',
  labelPositivo: 'Positivo',
  labelContaminado: 'Contaminado',
  geral_labelExportando: 'Exportando...',
  geral_labelSelecione: 'Selecione',
  geral_labelFILTRAR_EXPORTAR: 'FILTRAR E EXPORTAR',
  btnRemoverFiltros: 'REMOVER FILTROS',
  modalAtualVersao_labelAvisoImportante: 'Aviso importante!',
  modalAtualVersao_labelVocêEstaUtilizandoVersaoAntiga: 'Você está utilizando uma versão antiga: ',
  modalAtualVersao_labeljaEstaDisponivelNovaVersaoAplicativo: '. Já está disponível uma nova versão deste aplicativo: ',
  modalAtualVersao_labelCliqueBtnAtualApp: '. Clique no botão "Atualizar App" para continuar utilizando seus recursos.',
  modalAtualVersao_btnAtualizarApp: 'Atualizar App',
  modalAtualVersao_btnAgoraNao: 'Agora Não',
  geral_modalCancelarOperacao: 'Operação será cancelada, gostaria realmente de sair do fluxo?',
  geral_textoLeituraAutomaticaPlacaApresentacao: 'Leitura automática de Resultados',
  geral_textoAgoraVocePodePlacaApresentacao001: 'Agora você pode contar com a ',
  geral_textoAgoraVocePodePlacaApresentacao002: 'para ler as suas placas ',
  geral_textoAgoraVocePodePlacaApresentacao003: 'automaticamente',
  geral_textoAgoraVocePodePlacaApresentacao004: 'Ela é a nossa ',
  geral_textoAgoraVocePodePlacaApresentacao005: 'Inteligência Artificial',
  geral_textoAgoraVocePodePlacaApresentacao006: ' e vai trazer diversas novidades para facilitar o seu dia-a-dia.',
  geral_btnVerDicasFotografar: 'VER DICAS DE COMO FOTOGRAFAR',
  geral_btnAnexarFoto: 'ANEXAR FOTO',
  geral_btnProximaDica: 'VER PRÓXIMA DICA',
  geral_textoDica1Iluminacao001: 'Dica 1:  Iluminação!',
  geral_textoDica1Iluminacao002: 'Ligue a ',
  geral_textoDica1Iluminacao003: 'luz local',
  geral_textoDica1Iluminacao004: ' onde o ',
  geral_textoDica1Iluminacao005: 'Smartlab ',
  geral_textoDica1Iluminacao006: 'está instalado e também a ',
  geral_textoDica1Iluminacao007: 'luz da cabine',
  geral_textoDica1Iluminacao008: ' do SmartLab.',
  geral_textoDica1Iluminacao009: 'A boa luminosidade ajuda a ',
  geral_textoDica1Iluminacao010: 'realçar as cores',
  geral_textoDica1Iluminacao011: ' das bactérias e ',
  geral_textoDica1Iluminacao012: 'facilitar',
  geral_textoDica1Iluminacao013: ' o correto reconhecimento do algoritmo.',
  geral_labelInicieLançamento: 'Inicie um Lançamento',
  labelNovaMastiteClinicaSemCultura: 'Nova Mastite clínica SEM cultura',
  labelSelecioneQuarto: 'Selecione o Quarto',
  geral_labelMoeda: 'R$ ',
  labelOuDigiteCodigoBarras: 'Ou digite o código de barras',
  geral_labelLeituraPlacaUbere: 'Leitura da Placa - Úbere',
  geral_labelLeituraPlacaBezerra: 'Leitura da Placa - Bezerra',
  geral_textoCompartilhar: 'Compartilhar tratamento',
  geral_btnFinalizar: 'Finalizar',
  labelQuartoPE: 'PE',
  labelQuartoAE: 'AE',
  labelQuartoPD: 'PD',
  labelQuartoAD: 'AD',
  geral_ativarPopup: 'Ativar Pop-up ',
  geral_textoAtivarLeituraAutomDiag: 'Ativar leitura automática do diagnóstico',
  labelLeituraEm: 'Leitura em',
  geral_labelStatusMastiteClinica: 'Mastite clínica',
  geral_labelStatusMastiteSubClinica: 'Mastite sub clínica',
  geral_labelStatusMastiteSemCultura: 'Mastite sem cultura',
  geral_textoDica2PlacaCentralizada001: 'Dica 2:  Placa Centralizada',
  geral_textoDica2PlacaCentralizada002: 'Posicione a placa no ',
  geral_textoDica2PlacaCentralizada003: 'Suporte de Leitura  do Smartlab ',
  geral_textoDica2PlacaCentralizada004: ', e ajuste-a de forma correta e centralizada, evitando que ela fique torta.',
  geral_textoDica2PlacaCentralizada005: 'Isso pode ',
  geral_textoDica2PlacaCentralizada006: 'atrapalhar na identificação',
  geral_textoDica2PlacaCentralizada007: ' de qual amostra e etapa houve crescimento.',
  geral_textoDica3AtencaoMarcacao001: 'Dica 3:  Atenção à marcação',
  geral_textoDica3AtencaoMarcacao002: 'Aproxime',
  geral_textoDica3AtencaoMarcacao003: ' a câmera do celular de modo que a placa seja encaixada ',
  geral_textoDica3AtencaoMarcacao004: 'conforme as marcações',
  geral_textoDica3AtencaoMarcacao005: ' sugeridas.',
  geral_textoDica3AtencaoMarcacao006: 'O segredo é a foto que ocupar exatamente o espaço da marcação ',
  geral_textoDica3AtencaoMarcacao007: 'sem sobras',
  geral_textoDica3AtencaoMarcacao008: ' ao redor',
  geral_textoDica3AtencaoMarcacao009: 'Não mostrar as dicas novamente',
  labelNotificacoes: 'Notificações',
  geral_textNotificacaoRespQuestCuraCLinica: 'Responder Questões de Cura Clínica',
  geral_textNotificacaoAtualizarVacasLactacao: 'Atualizar Vacas em Lactação',
  geral_textNotificacaoPlaca: 'Placa ',
  geral_textNotificacaoProntaLeitura: ' pronta para leitura',
  geral_traducao0001: 'Estamos processando o relatório, e logo ele ficará disponível para download nas notificaões do OnFarmApp Web. Acesse o Link: app.onfarm.com.br.',
  geral_traducao0002: 'Desculpe mas houve um erro na geração do relatorio.',
  geral_traducao0003: 'Sem conexão com a internet',
  geral_traducao0004: 'Data de início maior que data de fim.',
  geral_traducao0005: 'Desativar pop-up',
  geral_traducao0006: 'Responder depois',
  geral_traducao0007: 'Sua resposta',
  geral_traducao0008: 'Enviar',
  geral_traducao0009: 'O grumo desapareceu e não voltou mais neste quarto',
  geral_traducao0010: 'CUROU',
  geral_traducao0011: 'Voltou ou continuou dando grumo neste quarto',
  geral_traducao0012: 'NÃO CUROU',
  geral_traducao0013: 'Foi descartada',
  labelSeca: 'Seca',
  geral_traducao0015: 'Próximo',
  geral_traducao0016: 'Confirmação',
  geral_traducao0018: 'Ver detalhes',
  geral_traducao0019: 'Remover este tratamento',
  geral_traducao0020: 'Adicionar este tratamento',
  geral_traducao0021: 'Inicio do tratamento:',
  labelIntramamario: 'Intramamário',
  labelAntiInflamatorio: 'Anti-Inflamatório',
  labelInjetavel: 'Injetável',
  labelNaoDefinido: 'Não definido',
  geral_traducao0026: 'Com a inclusão de um novo tratamento, todas as tarefas dos tratamentos anteriores que constarem em aberto serão interrompidas, gostaria de avançar?',
  geral_traducao0027: 'Usar este tratamento',
  geral_traducao0028: 'Tratamento adicionado',
  labelLado: 'Lado:',
  labelPlaca: 'Placa',
  labelCriacao: 'Criação',
  geral_traducao0034: 'Update:',
  geral_traducao0036: 'Teste SmartStrep:',
  geral_traducao0037: 'Agentes:',
  labelRealizarTratamento: 'Realizar tratamento?',
  geral_traducao0039: 'ou',
  geral_traducao0040: 'Escolher tratamento salvo:',
  labelVerTodos: 'Ver todos',
  labelAtivo: 'Ativo',
  labelInativo: 'Inativo',
  geral_traducao0044: 'Não existem tratamentos sugeridos para esse diagnóstico',
  labelAguardando: 'Aguardando',
  labelCurou: 'Curou',
  labelNaoCurou: 'Não Curou',
  labelDescartado: 'Descartado',
  labelNaoAnalisado: 'Não analisado',
  geral_traducao0052: 'Criar novo tratamento',
  geral_traducao0053: 'Nenhum Dado Encontrado',
  labelCompartilhar002: 'COMPARTILHAR',
  labelPrevalencaAgentes: 'Prevalência de agentes',
  labelFrequenciaCrescimento: 'Frequência de crescimento',
  geral_traducao0057: 'Histórico do animal',
  geral_traducao0058: 'Chance de Cura',
  geral_traducao0059: 'Média do seu rebanho',
  geral_traducao0060: 'Resultado do diagnóstico',
  geral_traducao0061: 'Tente mais tarde',
  geral_traducao0062: 'A solicitação de relatório foi enviado ao servidor',
  geral_traducao0063: 'Você receberá um notificação quando ele estiver disponível.',
  geral_traducao0064: 'Ver detalhes do cálculo:',
  geral_traducao0066: 'Alta',
  geral_traducao0067: 'Baixa',
  geral_traducao0068: 'Data de leitura:',
  geral_traducao0069: 'Confirmação Cura Clínica',
  geral_traducao0070: 'Por favor, informe o número de vacas em lactação deste mês, para gerar o cálculo de incidência de mastite clínica.',
  geral_traducao0071: 'Com Crescimento',
  geral_traducao0072: 'Sem Crescimento',
  geral_traducao0073: 'JANEIRO',
  geral_traducao0074: 'FEVEREIRO',
  geral_traducao0075: 'MARÇO',
  geral_traducao0076: 'ABRIL',
  geral_traducao0077: 'MAIO',
  geral_traducao0078: 'JUNHO',
  geral_traducao0079: 'JULHO',
  geral_traducao0080: 'AGOSTO',
  geral_traducao0081: 'SETEMBRO',
  geral_traducao0082: 'OUTUBRO',
  geral_traducao0083: 'NOVEMBRO',
  geral_traducao0084: 'DEZEMBRO',
  geral_traducao0085: 'Deseja realmente extender o tratamento?',
  geral_traducao0087: 'Tente novamente mais tarde!',
  geral_traducao0088: ' está disponível para download, para acessar o relatório utilize o aplicativo web.',
  geral_traducao0089: 'O Relatório de ',
  geral_traducao0090: 'O protocolo será encerrado a partir do dia ',
  returnGostariaRealmenteInterromperTratamento: 'Gostaria realmente de interromper o tratamento?',
  geral_traducao0092: 'Faturas próximas ao vencimento',
  geral_traducao0093: 'Placas prontas',
  geral_traducao0094: 'Só um momento enquanto consulto nossa ',
  geral_traducao0095: 'Não consta',
  geral_traducao0096: 'Não Realizado',
  geral_traducao0097: 'Informe o que aconteceu com o brinco',
  geral_traducao0098: 'referente a data',
  geral_traducao0099: 'base de dados',
  geral_traducao0100: 'CONTINUAR TAREFA',
  geral_traducao0101: 'INTERROMPER PROTOCOLO',
  kabekPresencaGrumo: 'Presença de Grumo',
  labelApliquei: 'Apliquei',
  labelNaoApliquei: 'Não apliquei',
  labelSalvarDiagnostico: 'SALVAR DIAGNÓSTICO',
  labelCuraClinicaPorTratamento: 'Cura clínica por tratamento',
  labelDataInicial: 'Data Inicial',
  labelDataFinal: 'Data Final',
  geral_traducao0109: 'CURA [SIM]',
  geral_traducao0110: 'CURA [NÃO]',
  labelIntramariosMaisUtilizadosComunidade: 'Intramamários mais utilizados pela comunidade OnFarmers',
  labelInjetaveisMaisUtilizadosComunidade: 'Injetáveis mais utilizados pela comunidade OnFarmers',
  labelAntiflamatoriosMaisUtilizadosComunidade: 'Antiflamatórios mais utilizados pela comunidade OnFarmers',
  labelDiasATBIntramamarioMaisUtilizadosComunidade: 'Dias de ATB intramamário mais utilizados pela comunidade de OnFarmers',
  labelCuraClinicaComunidade: 'Cura clínica pela comunidade OnFarmers',
  labelIncidenciaMastiteComunidade: 'Incidência de Mastite clínica pela comunidade OnFarmers',
  geral_traducao0117: 'Leitor de código de barras',
  geral_traducao0118: 'Leitura de teste',
  geral_traducao0119: 'REGISTRAR FOTO DA PLACA',
  geral_traducao0120: 'Em aberto',
  labelCancelado: 'Cancelado',
  labelConcluida: 'Concluída',
  labelAtrasada: 'Atrasada',
  geral_traducao0124: 'e quarto',
  geral_traducao0125: 'e quartos',
  geral_traducao0126: 'Realizou o Teste SmartStrep?',
  geral_traducao0127: 'Sim agalactiae',
  geral_traducao0128: 'Sim dysgalactiae',
  geral_traducao0129: 'Janeiro',
  geral_traducao0130: 'Fevereiro',
  geral_traducao0131: 'Março',
  geral_traducao0132: 'Abril',
  geral_traducao0133: 'Maio',
  geral_traducao0134: 'Junho',
  geral_traducao0135: 'Julho',
  geral_traducao0136: 'Agosto',
  geral_traducao0137: 'Setembro',
  geral_traducao0138: 'Outubro',
  geral_traducao0139: 'Novembro',
  geral_traducao0140: 'Dezembro',
  labelSelecioneTipoAmostra: 'Selecione o tipo de amostra:',
  geral_traducao0142: 'Grau Mastite:',
  geral_traducao0143: 'Selecione o lado:',
  labelMastiteClinicaGrumo: 'Mastite Clínica (Grumo)',
  geral_traducao0145: 'Mastite subclínica (CCS alta)',
  geral_traducao0146: 'Exame Microbiológico do Tanque',
  geral_traducao0147: 'Tem certeza que deseja substituir o Tratamento? As tarefas em aberto do tratamento atual serão interrompidas',
  geral_traducao0148: 'Deseja mesmo salvar este tratamento?',
  geral_traducao0149: 'Usuário não habilitado para compra.',
  geral_traducao0150: 'Pós Parto',
  labelQuantidadeOuPorcentagem: 'Quantidade ou Porcentagem',
  labelQuantidade: 'Quantidade',
  labelPorcentagem: 'Porcentagem',
  geral_traducao0154: 'Grau',
  geral_traducao0156: 'Soma de Escores',
  geral_traducao0157: '4 ou menos',
  geral_traducao0158: 'maior que 6',
  geral_traducao0159: 'Pneumonia',
  geral_traducao0160: 'Diarreia',
  geral_traducao0161: 'Data de Nascimento',
  geral_traducao0162: 'Idade',
  geral_traducao0163: 'Fezes',
  geral_traducao0164: 'Nariz',
  geral_traducao0165: 'Olho',
  geral_traducao0166: 'Houve crescimento?',
  geral_traducao0167: 'PROSSEGUIR',
  geral_traducao0168: 'Selecione a amostra:',
  labelLancamentoConcluidoSalveDiagnostico: 'Lançamento concluído! Salve seu diagnóstico:',
  geral_traducao0170: 'Data coleta:',
  geral_traducao0171: 'Produção de leite de vaca (L):',
  geral_traducao0172: 'Média de dias de descarte de leite quando tem tratamento (dias):',
  geral_traducao0173: 'Preço/litro de leite (R$):',
  geral_traducao0174: 'Preço/aplicação (R$):',
  geral_traducao0175: 'Número de aplicações/caso de mastite:',
  geral_traducao0176: 'Azul Claro/esverdeado (3 ou + colônias)',
  geral_traducao0177: 'Azul Escuro Metálico (3 ou + colônias)',
  geral_traducao0178: 'Roxo Escuro (3 ou + colônias)',
  geral_traducao0179: 'Amarelo/Esverdeado (3 ou + colônias)',
  geral_traducao0180: 'Azul Claro esverdeado (3 ou + colônias)',
  geral_traducao0181: 'Branco-cinzento sem brilho (3 ou + colônias)',
  geral_traducao0182: 'Cremosa - Brilhosa (3 ou + colônias)',
  geral_traducao0183: 'Roxa/Vinho (3 ou + colônias)',
  geral_traducao0184: 'Indique a cor das colônias exibidas:',
  geral_traducao0185: 'Outros Gram-pos',
  geral_traducao0186: 'Prototheca / Levedura',
  geral_traducao0187: 'Staph não aureus',
  geral_traducao0188: 'Amostra do lado',
  geral_traducao0189: 'Registrada com sucesso!',
  geral_traducao0190: 'Deseja registrar lado',
  geral_traducao0192: 'Diagnóstico do Lado',
  geral_traducao0193: 'Isso não costuma levar',
  geral_traducao0194: 'Selecione o Grau',
  geral_traducao0195: 'salvo com sucesso!',
  geral_traducao0196: 'Você ainda não definiu um tratamento para este caso',
  geral_traducao0197: 'SEGUIR SEM DEFINIR UM TRATAMENTO',
  geral_traducao0198: 'ESCOLHER UM TRATAMENTO',
  geral_traducao0199: 'Abra a tampa da placa e posicione sobre o suporte de leitura',
  geral_traducao0200: 'Selecione um protocolo de tratamento',
  geral_traducao0201: 'Inconcistência nos dados enviados, tente novamente mais tarde.',
  geral_traducao0202: 'Escolha uma opção',
  geral_traducao0203: 'Dica da Rumi',
  geral_traducao0204: 'Tratamento Salvo',
  geral_traducao0205: 'Acessar com Biometria',
  geral_traducao0206: 'Sem tratamento',
  geral_traducao0207: 'Todos',
  geral_traducao0208: 'Data leitura:',
  geral_traducao0209: 'Escolher Tratamento',
  geral_traducao0210: 'Realizar Tratamento?',
  geral_traducao0211: 'Por favor, selecione um tratamento, ou marque que não irá realizar tratamento.',
  geral_traducao0212: 'Remover',
  geral_traducao0213: 'Reprocessar Leitura?',
  geral_traducao0214: 'ESTENDER PROTOCOLO',
  labelDiario: 'Diário',
  labelMensal: 'Mensal',
  labelDiarioOuMensal: 'Diário Ou Mensal:',
  geral_traducao0218: 'Vacas em Lactação',
  geral_traducao0219: 'Qtd Incidência',
  geral_traducao0220: 'Periodos de aplicação',
  geral_traducao0221: 'Adicionar Tratamento',
  geral_traducao0222: 'INSERIR NOVO TRATAMENTO',
  geral_traducao0223: 'Dica da',
  geral_traducao0224: 'indisponível',
  geral_traducao0225: 'Neste momento, a análise da Rumi para o',
  geral_traducao0226: 'Score de Chance de Cura',
  geral_traducao0227: 'só está disponível na leitura de resultados de Mastite Clínica',
  returnVoceEstaTentandoConcluirTarefaPrevista: 'Você está tentando concluir uma tarefa prevista para ',
  returnDesejaMesmoMarcarTarefaConcluida: ' Deseja mesmo marcar a tarefa como concluída?',
  geral_traducao0230: 'Data diagnóstico',
  geral_traducao0231: 'Digite um brinco',
  geral_traducao0232: 'Outros Gram-neg',
  geral_traducao0233: 'Discorda deste resultado?',
  geral_traducao0234: 'Lançar manualmente',
  geral_traducao0235: 'SALVAR DIAGNÓSTICO LADO',
  geral_traducao0236: 'Outras cores (3 ou + colônias)',
  geral_traducao0237: 'Rosa (1 ou + colônias)',
  geral_traducao0238: 'Rosa Claro (3 ou + colônias)',
  geral_traducao0239: 'Loja',
  geral_traducao0240: 'Pontos',
  labelAcessar: 'Acessar',
  geral_traducao0244: 'Ler resultados',
  geral_traducao0245: 'Conheça o nosso produto de',
  geral_traducao0246: 'monitoramento do tanque',
  geral_traducao0247: 'Saiba mais aqui',
  geral_traducao0248: 'Oferecido por',
  geral_traducao0249: 'Última atualização',
  geral_traducao0250: 'TAMPA ABERTA',
  geral_traducao0251: 'VERIFICAR FALHA COMUNICAÇÃO',
  geral_traducao0252: 'VERIFICAR PROBLEMA SENSOR',
  geral_traducao0253: 'PULAR TUTORIAL',
  geral_traducao0254: 'Dados em sincronização.',
  geral_traducao0255: 'Se alguma informação estiver faltando, aguarde a sincronização finalizar e retorne a esta tela em breve.',
  geral_traducao0256: 'Erro interno, favor reparar banco de dados.',
  geral_traducao0257: 'Tem certeza que deseja reprocessar o Diagnóstico? Consta um tratamento relacionado, as tarefas em aberto serão interrompidas.',
  geral_traducao0258: 'Rúmi fora do ar - Sem internet',
  geral_traducao0259: 'Sincronizar agora',
  geral_traducao0260: 'dado',
  labelCodigoBarras: 'Código de barras',
  geral_traducao0262: 'Código de barras inválido',
  geral_traducao0263: 'Código de barras já utilizado',
  geral_traducao0264: 'Editar a foto',
  geral_traducao0265: 'Sem Internet',
  geral_traducao0266: 'Acessar com a biometria',
  geral_traducao0267: 'Período de tratamento',
  geral_traducao0268: 'DICA DA RUMI',
  geral_traducao0269: 'Ocultar',
  geral_traducao0270: 'DIVERGÊNCIA DE RESULTADO',
  geral_traducao0271: 'Prometo que na próxima eu acerto!',
  geral_traducao0272: 'Apesar de ter',
  geral_traducao0273: 'altíssima de acurácia',
  geral_traducao0274: 'na minha análise de resultados, vez ou outra podemos ter alguma divergência!',
  geral_traducao0275: 'Mas não se preocupe, você pode fazer o seu diagnóstico manualmente e nossos analistas farão um processo rígido de conferência.',
  geral_traducao0276: 'DEFINIR DIAGNÓSTICO MANUAL',
  geral_traducao0277: 'Resultados baseados na base de dados dos OnFarmers.',
  geral_traducao0278: 'Esta é apenas uma listagem com os tratamentos que apresentaram maior potencial de chance de sucesso de acordo com a base de dados dos OnFarmers.',
  geral_traducao0279: 'Para recomendações de tratamento, consulte a opinião do seu médico veterinário.',
  geral_traducao0280: 'Importante: os medicamentos abaixo estão listados por ordem de utilização.',
  geral_traducao0281: 'Sem indicações',
  geral_traducao0282: 'Mostrar mais 4 opções',
  geral_traducao0283: 'Compartilhar com Veterinário',
  geral_traducao0284: 'Digite uma descrição',
  geral_traducao0285: 'Bacterias da Diarréia',
  geral_traducao0286: 'Soro',
  geral_traducao0287: 'Teste de diarreia',
  geral_traducao0288: 'Teste de Tristeza',
  geral_traducao0289: 'Visualizar doença',
  geral_traducao0290: 'Data fim',
  geral_traducao0291: 'Data Inicio',
  geral_traducao0292: 'SALVAR DOENÇA',
  geral_traducao0293: 'Escore olho',
  geral_traducao0294: 'Secreção Nasal',
  geral_traducao0295: 'Imagem indisponível',
  geral_traducao0296: 'Temperatura retal',
  geral_traducao0297: 'Data cura clínica',
  geral_traducao0298: 'Brinco Bezerra',
  geral_traducao0299: 'Nova doença',
  geral_traducao0300: 'Não foi realizada analise de cultura',
  geral_traducao0301: 'Ops, parece que há algo errado com a sua ',
  geral_traducao0302: 'conexão',
  geral_traducao0303: 'Rumi',
  geral_traducao0304: ' está tentando acessar os servidores para realizar a leitura mas não está conseguindo.',
  geral_traducao0305: 'Isso pode acontecer quando sua ',
  geral_traducao0306: ' com a internet está  ',
  geral_traducao0307: 'instável ou inexistente',
  geral_traducao0308: 'Ops, parece que há algo errado com ',
  geral_traducao0309: 'nossos servidores',
  geral_traducao0310: ' está tentando acessar os servidores para realizar a leitura mas não está conseguindo.',
  geral_traducao0311: 'Isso pode acontecer quando existe alguma instabilidade do ',
  geral_traducao0312: 'lado de cá',
  geral_traducao0313: 'Mas não se preocupe, já estamos investigando o que pode ter acontecido e resolveremos o ',
  geral_traducao0314: 'mais breve',
  geral_traducao0315: ' possível.',
  btnTentarNovamente: 'TENTAR NOVAMENTE',
  geral_traducao0317: 'FAZER DIAGNÓSTICO MANUAL',
  geral_traducao0318: 'Doses',
  returnRumiNaoProcessada: 'Rumi não processada, favor reprocessar leitura.',
  labelChanceCura: 'CHANCE DE CURA',
  labelRegistrado: 'registrado',
  returnValidacaoCognitoEmailSenha: 'E-mail e/ou senha incorretos.',
  labelAgentSiglaAg: 'Ag',
  labelHoje: 'Hoje',
  labelAtrasadas: 'Atrasadas',
  labelAbertas: 'Abertas',
  labelConcluidas: 'Concluídas',
  labelCanceladas: 'Canceladas',
  labelDias: 'dias',
  labelOu: 'ou',
  labelMeses: 'Meses',
  labelAindaNaoTemDados: 'Ainda não tem dados',
  labelExportar: 'Exportar',
  labelRelatóriosProcessados: 'Relatórios Processados',
  labelCasosMastiteTratamentosDia: 'Casos Mastite e tratamentos por dia',
  returnDesejaMesmoEditar: 'Deseja mesmo editar o ',
  returnDesejaMesmoEditarLancamentoMastite: 'lançamento de mastite?',
  labelFechar: 'Fechar',
  labelSelecioneUmLado: 'Selecione um Lado',
  labelDigiteCodigoBarras: 'Digite um código de barras',
  labelDataExame: 'Data do Exame',
  labelDataLeitura: 'Data da Leitura',
  labelVerificando: 'Verificando',
  labelRevisarLeituraAutomatica: 'Revisar Leituras Automáticas',
  labelLancamentos: 'Lançamentos',
  labelExameMicrobiologicoLancamentoLote: 'Exame Microbiológico Lançamento em Lote',
  returnDesejaMesmo: 'Deseja mesmo',
  returnRemoveResultado: 'remover o Resultado?',
  returnDadosSalvoSucesso: 'Dados salvo com sucesso!',
  returnOcorreuErroSalvarDadosTenteNovamente: 'Ocorreu um erro ao salvar os dados, tente novamente!',
  labelConfirmarSenha: 'Confrimar Senha',
  labelAlterar: 'Alterar',
  labelAlterando: 'Alterando',
  returnCamposObrigatorios: 'Os campos são obrigatórios',
  returnSenhaInferiorDigitos: 'Senha inferior a 6 dígitos',
  returnSenhasDiferentes: 'Senhas diferentes',
  labelTipoDocumento: 'Tipo de documento',
  labelValor: 'Valor',
  labelNumeroDocumentoFiscal: 'Nº documento fiscal',
  labelNenhumItem: 'Nenhum Item',
  labelDataVencimento: 'Data vencimento',
  labelDocumento: 'Documento',
  labelAcompanheEntrega: 'ACOMPANHE A ENTREGA',
  labelCopiarCodigoRastreamento: 'COPIAR CÓDIGO DE RASTREAMENTO',
  labelQuantidadePlacas: 'Qtd. Placas',
  labelSemCodigoRastreio: 'Sem código de rastreio',
  returnJaExisteLancamento: 'Já existe um lançamento de Vacas em Lactação, deseja substituí-lo?',
  labelSelecioneData: 'Favor selecione a data',
  returnDigiteQuantidadeValida: 'Favor digite uma quantidade válida',
  labelSelecioneFazenda: 'Selecione a fazenda',
  labelSelecionePerfil: 'Selecione o perfil',
  labelSelecioneTipo: 'Selecione o tipo',
  labelSelecioneCategoria: 'Selecione a categoria',
  labelTutoriais: 'Tutoriais',
  labelIntegracaoParceiros: 'Integração Parceiros',
  labelHabilitar: 'Habilitar',
  labelIdentificacaoFazenda: 'Identificação Fazenda',
  labelDataLacamento: 'Data de lançamento',
  labelLerCodigoBarras: 'LER CÓDIGO DE BARRAS',
  labelCodigoRegistrado: 'CÓDIGO REGISTRADO',
  labelDescricaoTanque: 'Descrição do tanque',
  returnFavorImagemAntesSelecionar: 'Favor anexe a imagem antes de selecionar o modo de contagem das colônias',
  returnTanqueSalvoSucesso: 'Tanque salvo com sucesso',
  labelOpcional: 'Opcional',
  labelMinimo9Digitos: 'Mínimo de 9 dígitos',
  labelDia: 'Dia',
  labelAberta: 'Aberta',
  labelCancelada: 'Cancelada',
  labelAdicionar: 'Adicionar',
  labelSelecionarMedicamento: 'Selecione o medicamento',
  labelPeriodosAplicacao: 'Períodos de aplicação',
  labelConcluirTratamento: 'CONCLUIR TRATAMENTO',
  labelConcluirTarefas: 'CONCLUIR TAREFAS',
  labelInterromperTratamento: 'INTERROMPER TRATAMENTO',
  labelEstenderTratamento: 'ESTENDER TRATAMENTO',
  labelInformeAplicou: 'Informe se aplicou o ',
  labelInformeHouvePresencaGrumo: 'Informe se houve presença de grumo.',
  labelTratamentoSeraEncerradoPartirDia: 'O tratamento será encerrado a partir do dia',
  labelDe: 'de',
  returnDesejaMesmoInterromperTratamento: 'Deseja mesmo interromper o tratamento?',
  returnDesejaMesmoExtenderTratamento: 'Deseja mesmo extender o tratamento?',
  labelRealizarTarefa: 'Realizar tarefa',
  labelAtiveDesativeNotificacoes: 'Ative ou desative as notificações',
  returnFavorAguardeProcessamento: 'Favor aguarde o processamento',
  returnFavorInserirDigitosPlaca: 'Favor inserir os 9 dígitos da placa',
  returnColostroCriadoSucesso: 'Colostro criado com sucesso',
  returnCampoObrigatorio: 'Campo Obrigatório',
  returnBrincoCampoObrigatorio: 'Brinco é um Campo Obrigatório',
  returnCampoBrincoNaoPodeFicarVazio: 'Campo Brinco não pode ficar vazio',
  returnPorFavorSelecioneTratamento: 'Por favor selecione um Tratamento',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoTratamentoAtualSeraoInterrompidas: 'Tem certeza que deseja substituir o Tratamento? As tarefas em aberto do tratamento atual serão interrompidas.',
  returnTemCertezaDesejaSubstituirTratamentoTarefasAbertoSeraoInterrompidas: 'Tem certeza que deseja substituir o Tratamento? As tarefas em aberto serão interrompidas.',
  returnTemCertezaDesejaRemoverTratamentoTarefasAbertoSeraoInterrompidas: 'Tem certeza que deseja remover o Tratamento? As tarefas em aberto serão interrompidas.',
  returnTemCertezaDesejaExcluirTratamentoTarefasRelacionadasSeraoExcluidas: 'Tem certeza que deseja excluir o Tratamento? As tarefas relacionadas também serão excluídas.',
  returnFavorSelecionePeloMenosMedicamento: 'Favor selecione pelo menos um medicamento',
  returnFavorSelecioneIntervaloAplicacao: 'Favor selecione um intervalo de aplicação',
  returnFavorSelecioneTratamentoNaoAtivo: 'Favor selecione se o tratamento é ou não ativo',
  returnFavorSelecioneBacteria: 'Favor selecione a bactéria',
  returnErroProcessarRelatorioTenteNovamenteMaisTarde: 'Erro ao processar relatório, tente novamente mais tarde',
  returnCompartilhamentoRealizadoSucesso: 'Compartilhamento realizado com sucesso',
  returnHouveFalhaNaoFoiPossivelProcessarCompartilhamentoTenteMaisTarde: 'Houve uma falha e não foi possível processar o compartilhamento, tente mais tarde',
  returnFavorPreenchaTodosCampos: 'Favor preencha todos os campos',
  returnErroComunicarOmie: 'Erro ao se comunicar com o Omie',
  returnVoceNaoInformouNomeUsuario: 'Você não informou o nome do usuário',
  returnVoceNaoInformouLoginUsuario: 'Você não informou o login do usuário',
  returnVoceNaoInformouFazenda: 'Você não informou a fazenda',
  returnVoceNaoInformouPerfilUsuario: 'Você não informou o Perfil do usuário',
  returnVoceNaoInformouTelefoneEnviaremosSenhaNumeroInformado: 'Você não informou o Telefone. Enviaremos a senha para o número informado.',
  returnTelefoneInvalido: 'Telefone inválido!',
  returnUsuarioJaEstaEmUso: 'Usuário já está em uso',
  returnVoceDigitouCodigoDeBarrasEleDeveTerMinimoDigitos: 'Você digitou o código de barras, ele deve ter no mínimo de 9 dígitos',
  returnDescricaoTanqueObrigatoria: 'Descrição do tanque obrigatória',
  returnVoceJaLancou: 'Você já lançou',
  returnEtapasDesejaContinuarLancamento: '/3 etapas, deseja continuar o lançamento?',
  returnInformeHouveCrescimento: 'Informe se houve crescimento.',
  returnInformeCorColoniaObsPlacaConsulteGuiaCores: 'Informe a cor da colônia observada na placa. Consulte o Guia de Cores.',
  returnArquivoEnviadoComSucesso: 'Arquivo enviado com Sucesso!',
  returnHouveErroImportarArquivoTenteNovamenteMaisTarde: 'Houve um erro ao importar o arquivo, tente novamente mais tarde!',
  returnNecessarioSelecionarArquivo: 'Necessário selecionar um Arquivo',
  returnVoceSelecionouMastiteClinicaPorFavorSelecioneTambemGrau: 'Você selecionou mastite clínica, por favor selecione também o Grau',
  returnPorFavorInformeCodigoBarrasComDigitos: 'Por favor informe o código de barras com 9 dígitos',
  returnPorFavorInformeBrincoAnimal: 'Por favor informe o brinco do animal',
  returnSelecioneQuarto: 'Selecione o quarto',
  returnEssaPlacaFoiUtilizadaParaLadoAE: 'Essa Placa já foi utilizada para lado [A] e ',
  returnPorFavorVerifiqueSeNaoDeixouNenhumCampoBranco: 'Por favor verifique se não deixou nenhum campo em branco',
  returnInformacoesDiagnostico: 'Informações do diagnóstico',
  returnANaoEncontradas: 'A não encontradas',
  returnFavorSelecioneMedicamento: 'Favor selecione o medicamento',
  returnFavorSelecionePeloMenosBacteria: 'Favor selecione pelo menos uma bacteria',
  returnFavorSelecionePeloMenosGrau: 'Favor selecione pelo menos um Grau',
  returnFavorSelecionePeloMenosObs: 'Favor selecione pelo menos uma Observação',
  returnSelecioneAoMenosFazenda: 'Selecione ao menos uma fazenda.',
  returnTemCertezaQueDesejaReprocessarOResultadoAgentesInformadosAnteriormenteSeraoExcluidos: 'Tem certeza que deseja reprocessar o resultado? Os agentes informados anteriomente serão excluídos.',
  returnVoceNaoSelecionouNenhumaFazenda: 'Você não selecionou nehuma fazenda',
  returnCompartilhamentoRealizadoComSucesso: 'Compartilhamento realizado com sucesso',
  returnDesejaExcluirResultado: 'Deseja excluir o resultado?',
  labelFoto: 'FOTO',
  returnDesejaAssociarTratamentoNovaDoenca: 'Deseja associar um tratamento a essa nova doença?',
  labelDeletar: 'Deletar',
  labelAnexarFotoPlaca: 'ANEXAR FOTO DA PLACA'
}
